<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">
			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>Veranstaltungsformular übersicht</span>
			</div>
			<mat-spinner diameter=30 [ngStyle]="{ opacity: bLoading ? 1 : 0 }" />
		</div>

		<div style="padding:1em; margin: 0em auto 0 auto; position: relative">

			@if( !bLoading ) {

				@if( !event.id ) {
					<div class="errorMessage">
						Beim Abrufen der Details des Ereignisses ist ein Fehler aufgetreten
					</div>
				}
				@else if( !answer.vbId ) {
					<div class="errorMessage">
						Beim Abrufen der Antworten des Formulars ist ein Fehler aufgetreten
					</div>
				}
				@else {
					
					<dynamic-form-readonly
						[event]="event"
						[answer]="answer"
					/>

				}


			}

		</div>

	</div>

</div>

